import script from "./UploadDeparture.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadDeparture.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__